// Multivariate Dependencies
import React from 'react';
// Components
import { ContainerLegacy, AnimatedContainerLegacy } from '../styles/Containers';
// Styles
import { pulseAnimation } from './styles/pulseAnimation';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var Skeleton = function () { return (React.createElement(ContainerLegacy, { background: 'linear-gradient(-90deg, #dcdcdc4d 0%, #fcfcfc4d 50%, #dcdcdc4d 100%)', display: 'block', overflow: 'hidden', width: '100%', "data-testid": 'skeleton', borderRadius: '3px' },
    React.createElement(AnimatedContainerLegacy, { display: 'inline-block', position: 'relative', left: '-50px', width: '50px', background: 'linear-gradient(-90deg, #dddddd4d 0%, #acacac1a 50%, #dddddd4d 100%)', opacity: 1, animate: pulseAnimation }, "\u00A0"))); };
//# sourceMappingURL=Skeleton.js.map